<div class="seo-container" [formGroup]="seoForm">
  <div class="form-group">
    <div class="label" matTooltip="{{ 'SEO.WEB' | translate }}">{{ 'SEO.SEO_TITLE' | translate }}</div>
    <mat-form-field class="full-width">
      <mat-label>{{ 'SEO.SEO_TITLE' | translate }}</mat-label>
      <input matInput formControlName="seoTitle" id="RecipesModifyClassificationSEOTitletxt" />
      <mat-hint align="end">{{ seoForm.get('seoTitle')?.value.length }} / 70</mat-hint>
      <div *ngIf="seoForm.get('seoTitle')?.value?.length > 70" class="error-message">{{ 'SEO.SEO_TOO_LONG' | translate }}</div>
    </mat-form-field>
  </div>
  <div class="form-group">
    <div class="label" matTooltip="{{ 'SEO.WEB' | translate }}">{{ 'SEO.SEO_URL' | translate }}</div>
    <mat-form-field class="full-width">
      <mat-label>{{ 'SEO.SEO_URL' | translate }}</mat-label>
      <input id="RecipesModifyClassificationSEOUrlTxt" matInput formControlName="seoUrl" />
    </mat-form-field>
  </div>
</div>
<div class="buttons-container">
  <button class="btn-warn" mat-raised-button id="RecipesModifyClassificationSEOResetBtn" (click)="reset()" [disabled]="seoForm.pristine">
    {{ 'SEO.RESET' | translate }}
  </button>
  <button
    class="btn-submit space-l-s"
    mat-raised-button
    id="RecipesModifyClassificationSEOSaveBtn"
    (click)="save()"
    [disabled]="seoForm.invalid || seoForm.pristine"
  >
    {{ 'SAVE' | translate }}
  </button>
</div>
